import { createRootRoute, Outlet } from "@tanstack/react-router";
import { DiscardPromptHost } from "../components/shared/DiscardPrompt";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import { ApiError } from "../lib/api";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status < 500) return false;
        return failureCount < 3;
      },
    },
  },
});

function RootErrorFallback() {
  return (
    <div style={{ padding: 32, textAlign: "center", color: "var(--ink)" }}>
      <h2 style={{ margin: "0 0 8px" }}>Algo deu errado</h2>
      <p style={{ color: "var(--ink-soft)", marginBottom: 16 }}>
        A tela encontrou um erro inesperado. Recarregue a página.
      </p>
      <button
        onClick={() => window.location.reload()}
        style={{
          padding: "9px 16px",
          background: "var(--brand)",
          color: "#fff",
          border: "none",
          borderRadius: 8,
          cursor: "pointer",
        }}
      >
        Recarregar
      </button>
    </div>
  );
}

export const Route = createRootRoute({
  component: () => (
    <QueryClientProvider client={queryClient}>
      <Sentry.ErrorBoundary fallback={<RootErrorFallback />}>
        <Outlet />
        <DiscardPromptHost />
      </Sentry.ErrorBoundary>
    </QueryClientProvider>
  ),
});
